import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import AuditExamples from "@/components/AuditExamples";
import QuickForm from "@/components/QuickForm";
import Problem from "@/components/Problem";
import Framework from "@/components/Framework";
import Criteria from "@/components/Criteria";
import Deliverables from "@/components/Deliverables";
import Stats from "@/components/Stats";
import Qualification from "@/components/Qualification";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-white text-[#003E75] min-h-screen selection:bg-[#ED1C27] selection:text-white" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <AuditExamples />
        <QuickForm />
        <Problem />
        <Framework />
        <Criteria />
        <Deliverables />
        <Stats />
        <Qualification />
        <LeadForm />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
